import React, { useState } from "react";
import {
  convertToSearchField as convertToSearchField,
  generateColumnMetadata,
  mask
} from "../../utils/utils";
import DataGrid from "../../components/common/dataGrid/dataGrid";
import { commonPostApi } from "../../utils/apiService";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";

import DateSelect from "../../components/common/dateSelect";
import UsersImg from "../../assets/images/users.svg";
import User3Img from "../../assets/images/user-3.svg";
import "../../assets/styles/donorReport.scss";
import PrimaryHeader from "../../components/common/primaryHeader";
import { exportCSV, exportExcel, exportPdf } from "../../utils/exportUtils";
import { SORT_ORDER } from "../../constants/sortOrder";
import { DonorreportColumns } from "../../utils/serviceData";

const nonRequirePatientListField = [
  "patient_id",
  "created_at",
  "updated_at",
  "created_by",
  "updated_by",
  "profile_picture",
  "first_name",
  "last_name",
  "dob",
  "phone_no",
  "ration_card_no",
  "health_insurance_card",
  "address",
  "district",
  "state",
  "city",
  "pincode",
  "is_active",
  "is_deleted",
];
export default function DonorReportList() {
  const [columns, setColumns] = useState([]);
  const searchFields = ["patient_name","adhar_name", "patient_code","gender","treatment"];
  const [loading, setLoading] = useState(true);
  const [values, setValues] = useState([]);
  const [show, setShow] = useState(false);
  const [selectOption, setSelectOption] = useState(1);
  const [dataGridShow, setDataGridShow] = useState(false);
  const [dataGridSelectOption, setDataGirdSelectOption] = useState(1);
  const [dashboardData, setDonorDashBoard] = useState({});
  const [navigator, setNavigator] = useState({
    page: 1,
    first: 0,
    rows: 10,
    totalRecords: 1,
    sortBy: "patient_name",
    sortDir: SORT_ORDER.ASC,
    startDate: new Date(),
    endDate: new Date(),
    filterType: "today",
    searchCriteria: convertToSearchField(searchFields, ""),
  });

  const init = async (navigator) => {
    let currentObj = {
      startDate: navigator?.startDate,
      endDate: navigator?.endDate,
      filterType: navigator?.filterType,
      page: navigator?.page,
      limit: navigator?.rows,
      sortFields: [[navigator?.sortBy, navigator?.sortDir]],
      searchCriteria: navigator?.searchCriteria,
    };
    await commonPostApi(API_ENDPOINTS.DONOR_REPORT, currentObj)
      .then((data = []) => {
        if (data?.data?.data) {
          const finalData = data?.data?.data;
          const updatedPatient = finalData.map((p) => ({
            ...p,
            aadhar_no: mask(p.aadhar_no),
          }));
          setNavigator((prev) => ({
            ...prev,
            totalRecords: data?.data?.total,
            page: data?.data?.currentPage,
          }));

          setColumns(
            updatedPatient.length > 0
              ? generateColumnMetadata({
                  data: finalData,
                  nonRequireField: nonRequirePatientListField,
                  arrageArray: [
                    "patient_name",
                    "patient_code",
                    "aadhar_no",
                    "gender",
                    "treatment_recommended",
                  ],
                  alias: {
                    patient_name: "patient",
                    patient_code: "patient_id",
                    aadhar_no: "aadhaar",
                    treatment_recommended: "treatment",
                  },
                  defaultColumnsArr: DonorreportColumns,
                })
              : generateColumnMetadata({
                  data: [
                    {
                      patient_name: "",
                      patient_code: "",
                      aadhar_no: "",
                      gender: "",
                      treatment_recommended: "",
                    },
                  ],
                  nonRequireField: nonRequirePatientListField,
                  arrageArray: [
                    "patient_name",
                    "patient_code",
                    "aadhar_no",
                    "gender",
                    "treatment_recommended",
                  ],
                  alias: {
                    patient_name: "patient",
                    patient_code: "patient_id",
                    aadhar_no: "aadhaar",
                    treatment_recommended: "treatment",
                  },
                  defaultColumnsArr: DonorreportColumns,
                })
          );
          setValues(updatedPatient);
          setLoading(false);
        } else {
          setNavigator((prev) => ({
            ...prev,
            totalRecords: 1,
            page: 1,
          }));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchDonorReport = async (payload = { filterType: "today" }) => {
    await commonPostApi(API_ENDPOINTS.DONOR_REPORT_DASHBOARD, payload).then(
      (data) => {
        setDonorDashBoard(data?.data);
      }
    );
  };

  function onPageChange(event) {
    setLoading(true);
    setNavigator((prev) => ({
      ...prev,
      first: event?.first,
      page: event.page + 1,
    }));
    init({
      ...navigator,
      first: event?.first,
      page: event.page + 1,
    });
  }

  const onRowCountChange = (e) => {
    setLoading(true);
    setNavigator((prev) => ({
      ...prev,
      rows: e?.target?.value,
      page: 1,
      first: 0,
    }));
    init({
      ...navigator,
      page: 1,
      first: 0,
      rows: e?.target?.value,
    });
  };

  const onSortClick = (event) => {
    setLoading(true);
    const sortOrder = event?.sortOrder === 1 ? SORT_ORDER.ASC : SORT_ORDER.DESC;
    setNavigator((prev) => ({
      ...prev,
      sortBy: event?.sortField,
      sortDir: sortOrder,
      sortFields: [[event?.sortField, sortOrder]],
    }));
    init({
      ...navigator,
      sortBy: event?.sortField,
      sortDir: sortOrder,
      sortFields: [[event?.sortField, sortOrder]],
    });
  };

  const generatePayload = (date1, date2, selectedOption, dataGrid) => {
    const filterType = {
      1: "today",
      2: "week",
      3: "month",
      4: "custom",
    };
    const payload = {};
    payload.startDate = date1;
    payload.endDate = date2;
    payload.filterType = filterType[selectedOption];
    if (dataGrid === "dataGrid") {
      setNavigator((prev) => {
        init({
          ...prev,
          ...payload,
        });
        return {
          ...prev,
          ...payload,
        };
      });
    } else {
      fetchDonorReport(payload);
    }
  };

  function handleSearchChange(value) {
    setNavigator((prev) => ({
      ...prev,
      searchCriteria: convertToSearchField(searchFields, value),
    }));
    init({
      ...navigator,
      searchCriteria: convertToSearchField(searchFields, value),
    });
  }

  const fetchAllDonorReportList = async () => {

    const exportObj = {
      startDate: navigator.startDate,
      endDate: navigator.endDate,
      filterType: navigator.filterType,
      page: 1,
      limit: navigator.totalRecords,
      sortFields:[[navigator.sortBy, navigator.sortDir]],
      searchCriteria: navigator.searchCriteria,
    };
    const res = await commonPostApi(API_ENDPOINTS.DONOR_REPORT, exportObj);
    return res?.data?.data || [];
  };

  return (
    <div className=" Donor__report">
      <div className="py-4 px-3 mt-4 mb-4 Patients__date-container">
        <DateSelect
          show={show}
          onDateRangeChange={(date1, date2, selectedOption = 1) => {
            generatePayload(date1, date2, selectedOption);
          }}
          setShow={setShow}
          selectOption={selectOption}
          setSelectOption={setSelectOption}
        />
        <div className="">
          <ul className="donor__card-holder grid-column-2fr">
            <li>
              <div className="card-left-sec">
                <p className="card-title">Donated Amount</p>
                <p className="card-info">
                  <span className="total-count">
                    {dashboardData?.donated_amount || 0}
                  </span>
                </p>
              </div>
              <div className="card-right-sec">
                <span className="card-icon bg-one">
                  <img src={UsersImg} alt="" />
                </span>
              </div>
            </li>
            <li>
              <div className="card-left-sec">
                <p className="card-title">Number of Patients Treated</p>
                <p className="card-info">
                  <span className="total-count">
                    {dashboardData?.total_patients_treated || 0}
                  </span>
                </p>
              </div>
              <div className="card-right-sec">
                <span className="card-icon bg-three">
                  <img src={User3Img} alt="" />
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <DataGrid
        header={
          <div className="p-3 border-bottom-primary">
            <PrimaryHeader
              isCalenderEnabled={true}
              isDownloadButton={true}
              exportCSV={async () => {
                const allData = await fetchAllDonorReportList();
                exportCSV(allData, columns, "Donor_Patient_List");
              }}
              exportExcel={async () =>{
                const allData = await fetchAllDonorReportList();
                exportExcel(allData, columns, "Donor_Patient_List");
                }}
              exportPdf={async () => {
                const allData = await fetchAllDonorReportList();
                exportPdf(allData, columns, "Donor_Patient_List")
              }}
              isSearchEnabled={true}
              searchPlaceHolder={"Search Patients"}
              searchHeaderLable={"Patient List"}
              onChange={handleSearchChange}
              show={dataGridShow}
              onDateRangeChange={(date1, date2, selectedOption = 1) => {
                generatePayload(date1, date2, selectedOption, "dataGrid");
              }}
              setShow={setDataGridShow}
              selectOption={dataGridSelectOption}
              setSelectOption={setDataGirdSelectOption}
            />
          </div>
        }
        onSortClick={onSortClick}
        onRowCountChange={onRowCountChange}
        onPageChange={onPageChange}
        sortable={true}
        navigator={navigator}
        column={columns}
        value={values}
        loading={loading}
        isAccordionEnabled={false}
        isPaginatorEnabled={true}
      />
    </div>
  );
}
